/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

export function convertToCurrency(number, type){
  if(isNaN(number)){
    return '-';
  }
    
  switch (type){
    case 'USD' :
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);

    case 'GBP':
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(number);

    case 'EUR':
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(number);

    case 'BRL':
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number);

    case 'SGD':
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'SGD' }).format(number);

    case 'currency': 
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);

    case 'perc':
      return `% ${number.toFixed(5).toString()}`;

    default:
      return number;
  }
  
};
